import * as React from 'react';
type IconOtrosLegalesProps = React.SVGProps<SVGSVGElement>;

export const IconOtrosLegales: React.FC<IconOtrosLegalesProps> = (props) => (
	<svg
		width={62}
		height={60}
		viewBox="0 0 62 60"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<rect
			x="0.5"
			y="0.5"
			width="61"
			height="59"
			rx="4"
			fill="#EBF8F0"
		/>
		<path
			d="M10 24.5C10 22.567 11.567 21 13.5 21C15.433 21 17 22.567 17 24.5V54H10V24.5Z"
			fill="#7EAE90"
		/>
		<path
			d="M22 34C22 32.3431 23.3431 31 25 31C26.6569 31 28 32.3431 28 34V54H22V34Z"
			fill="#7EAE90"
		/>
		<path
			d="M33 29.5C33 27.567 34.567 26 36.5 26C38.433 26 40 27.567 40 29.5V54H33V29.5Z"
			fill="#7EAE90"
		/>
		<path
			d="M45 24C45 22.3431 46.3431 21 48 21C49.6569 21 51 22.3431 51 24V54H45V24Z"
			fill="#7EAE90"
		/>
		<circle
			cx="13"
			cy="11.5"
			r="3"
			fill="#FFA692"
		/>
		<circle
			cx="25"
			cy="21"
			r="3"
			fill="#FFA692"
		/>
		<circle
			cx="36"
			cy="14.5"
			r="3"
			fill="#FFA692"
		/>
		<circle
			cx="48"
			cy="7.5"
			r="3"
			fill="#FFA692"
		/>
		<path
			d="M13 11.5L25 21.5L36 14.5L48 7.5"
			stroke="#FFA692"
			stroke-width="2"
		/>
		<path
			d="M5.5 54H56.5"
			stroke="#7EAE90"
			stroke-linecap="round"
		/>
	</svg>
);

export default IconOtrosLegales;
